export default "__VITE_ASSET__B90$f374__"